// extracted by mini-css-extract-plugin
export var deleteModal = "_hh-0";